export enum MatchActions {
	CombineMatchingRecords,
	CombineMatchingIndexes,
	OnlyKeepMatchingRecordsFromCollectionA,
	OnlyKeepMatchingRecordsFromCollectionB,
	OnlyKeepNonMatchingRecords,
	OnlyKeepNonMatchingRecordsFromCollectionA,
	OnlyKeepNonMatchingRecordsFromCollectionB,
}
